module.exports = __webpack_public_path__ + "img/icon-date-brown.fe580552.svg";